var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.6 77.6",
    style: {
      enableBackground: "new 0 0 77.6 77.6"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2C2F73",
    d: "M77.6,55.1c-4.9,1.4-11.4,1.9-16.2,2l-22.7-45.8h-1.3l-22.6,45.8c-4.8-0.1-10.5-0.6-15.4-2l28.7-53.7h20.5 L77.6,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EBFD4",
    d: "M47.7,41.4c0,5.3-4.3,9.5-9.6,9.5c-5.3,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5 C43.4,31.9,47.7,36.1,47.7,41.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThales);
export default __webpack_public_path__ + "static/media/Thales.c77ed1e31a1f29f3c1252be952b78bfb.svg";
export { ForwardRef as ReactComponent };